import React from 'react';
import classnames from 'classnames';

const DropdownContainer = props => {
  const className = classnames('dropdown-container', props.className, {
    disabled: props.disabled,
    open: props.open,
    light: props.isLight,
  });

  return <div className={className}>{props.children}</div>;
};

DropdownContainer.propTypes = {
  open: React.PropTypes.bool,
  children: React.PropTypes.any,
  className: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  isLight: React.PropTypes.bool,
};

export default DropdownContainer;



// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown-container.jsx